import { ref } from '@vue/composition-api';
import { nanoid } from 'nanoid';
import dateTypesService from '@/services/datatypes';
import checkNull from '@/utils/checkNull';
import useDataTypeActions from '@/router/routes/datatypes/item/useDataTypeActions';

export default (props, context) => {
  const entity = ref(null);
  const entityLocal = ref(null);
  const { actions } = useDataTypeActions(props, context, entity);

  const loadData = async id => {
    const object = await dateTypesService.getOneDataType(id);

    entity.value = object.data.propertyType;
    entity.value._updateEntity = loadData;

    entityLocal.value = {
      image: '/img/datatype.png',
      id: object.data.propertyType.id,
      title: object.data.propertyType.name,
      contextMenu: actions,
      tabsMeta: [
        {
          id: 'general',
          title: 'properties',
          type: 'properties'
        }
      ],
      tabs: [
        {
          items: [
            {
              id: nanoid(),
              subheader: 'General',
              contextMenu: [
                {
                  id: 'copy',
                  text: 'Copy',
                  icon: '',
                  _enabled: true
                }
              ],
              properties: [
                {
                  id: nanoid(),
                  title: object.data.propertyType.id,
                  subtitle: '',
                  icon: {
                    name: 'mdi-identifier'
                  },
                  isHoverAction: false,
                  contextMenu: []
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'Description',
              contextMenu: [],
              properties: [
                {
                  id: nanoid(),
                  title: checkNull(object.data.propertyType.description),
                  subtitle: '',
                  icon: 'none',
                  isHoverAction: false,
                  contextMenu: []
                }
              ]
            },
            {
              id: nanoid(),
              subheader: 'Schema',
              contextMenu: [],
              properties: [
                {
                  id: nanoid(),
                  title: checkNull(object.data.propertyType.schema),
                  subtitle: '',
                  icon: 'none',
                  isHoverAction: false,
                  contextMenu: []
                }
              ]
            }
          ],
          additionalItems: []
        }
      ]
    };
  };

  return {
    entity,
    entityLocal,
    loadData
  };
};
